module.exports = __webpack_public_path__ + "hero-next-320-73cd4f56b6fb3d24e93592b56aa6e248.bundle.png";